import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const ContactsRedux = createActions({}, {
  prefix: 'CONTACTS_',
  defaultActions: {
    get: true,
    getOne: true,
    create: true,
    remove: true,
  },
})

const { Types, Creators } = ContactsRedux
export const ContactsTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
  getOne: true,
  create: true,
  remove: true,
})

export const reducer = createReducer(INITIAL_STATE, {}, {
  defaultActions: {
    get: true,
    getOne: true,
    create: true,
    remove: true,
  },
  Types,
})



// WEBPACK FOOTER //
// ./src/Data/Redux/ContactsRedux.js